import { type z } from 'zod';

import { makeListQuery } from '../../common/list-query/list-query';
import { ReportReasonCodeSchema } from '../report-reason/report-reason';
import { ReportStatusSchema } from '../report-status/report-status';

/**
 * The whitelisted filters of the reports review queue (N7).
 *
 * Two, and the omissions are the design — the same reasoning
 * `SignalMatchesListQuerySchema` states. `status` is what a reviewer works by:
 * the queue opens on `pending_review` (a default the *service* chooses, never
 * this schema — a default here would read as though resolved reports were
 * unreachable) and the resolved rows stay readable, because a decision nobody
 * can find afterwards is a decision nobody can undo. `reason` is how a run of
 * the same complaint is worked together, and it is the one that matters most:
 * `underage` is a legal obligation rather than a preference, and a reviewer must
 * be able to see every one of them at once.
 *
 * There is deliberately **no member filter**. `reportedUserId` would turn a work
 * list into a per-member dossier and `reporterUserId` into a way to pull up
 * everything one member has ever complained about — the same reason the Trust
 * and verification queues have neither. The number a reviewer actually needs
 * about a member travels on the row itself
 * (`Report.openReportsAgainstMember`).
 */
export const ReportsListQuerySchema = makeListQuery({
  status: ReportStatusSchema.optional(),
  reason: ReportReasonCodeSchema.optional(),
});

export type ReportsListQuery = z.infer<typeof ReportsListQuerySchema>;
